import React, { useCallback, useEffect, useState } from "react";

// region Libraries
import { Outlet } from "react-router-dom";
import { useLazyQuery } from "@apollo/client";
import { getUserClaimsByModule } from "src/store/graphql/groups/claim/query.graghql";
import { EGraphQLClients, moduleClients } from "src/store/graphql/client";
import { useToast } from "@npm-telluria-tecnologia/telluria-ui";
import { ECommandResultStatus } from "src/store/graphql/helpers/types.graphql";
import { usePermissions } from "src/store/jotai";
// endregion Libraries
// region Atoms
import Loading from "@atoms/Loading";

// endregion Atoms
// region Molecules
import Sidebar from "@molecules/Sidebar";
// endregion Molecules
// region Organisms
import { Navbar } from "@molecules/index";
// endregion Organisms

// region Hooks
import { useAuth } from "@hooks/useAuth";
// endregion Hooks
// region Styles
import * as Styled from "./styles";
// endregion Styles

const Office: React.FC = () => {

  const [QueryGetUserClaimsByModule] = useLazyQuery(getUserClaimsByModule());

  const { addToast } = useToast();
  const { getActiveAccount } = useAuth();
  const activeAccount = getActiveAccount();
  const { setValue: setPermissions } = usePermissions();

  const [isLoading, setIsLoading] = useState(true);

  const getCurrentUserClaims = useCallback(async () => {
    try {
      const query = await QueryGetUserClaimsByModule(
        {
          variables: {
            idModule: moduleClients[EGraphQLClients.IDENTITY].moduleId
          },
          fetchPolicy: "no-cache"
        }
      );

      const response = query.data?.claim.getMyClaimsByModule;

      if (response?.status !== ECommandResultStatus.SUCCESS) return [];

      return response?.result;

    } catch (internalError) {
      addToast({ type: "error", title: "Internal client error", description: internalError.message });

      return [];
    }
  }, [QueryGetUserClaimsByModule, addToast]);

  useEffect(() => {
    const loadPermissions = async () => {
      const currentUserClaims = await getCurrentUserClaims();

      const formattedUserClaims = currentUserClaims.map(
        (claim: any) => `${claim.claimGroup.permissionGroup.alias}.${claim.claimGroup.alias}.${claim.alias}`
      );

      setPermissions(formattedUserClaims);

      setIsLoading(false);
    };

    // Load permissions immediately
    loadPermissions();

    // Set up interval to reload permissions every 5 minutes
    const interval = setInterval(loadPermissions, 5 * 60 * 1000);

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, [getCurrentUserClaims, setPermissions]);

  return (
    isLoading ? (
      <Loading loading={isLoading} />
    ) : (
      <Styled.Container>
        <Styled.NavbarContainer>
          <Navbar />
        </Styled.NavbarContainer>
        <Styled.ContentContainer>
          <Sidebar />
          <Styled.Content id="officeContent">
            <Outlet />
          </Styled.Content>
        </Styled.ContentContainer>
      </Styled.Container>
    )
  );
};

export default Office;
